module.exports = __webpack_public_path__ + "img/esm50.d44eb682.png";